import { HighlightText } from '@/components/common/HighlightText';
import { CODE_BADGE_CLASS } from '@/styles/codeBadge';

interface InstituteNumbersProps {
  code: number | null;
  eiin: string | null;
  highlightedText?: string | undefined;
}

interface LabeledNumber {
  label: string;
  value: string;
}

export function InstituteNumbers({ code, eiin, highlightedText }: InstituteNumbersProps) {
  const numbers: LabeledNumber[] = [];
  if (code !== null) numbers.push({ label: 'Inst. Code', value: String(code) });
  if (eiin) numbers.push({ label: 'EIIN', value: eiin });
  if (numbers.length === 0) return null;

  return (
    <span className="flex flex-wrap items-center gap-x-3 gap-y-1 tabular-nums">
      {numbers.map((number) => (
        <span key={number.label} className="flex items-center gap-1.5">
          {number.label}
          <span className={CODE_BADGE_CLASS}>
            <HighlightText text={number.value} highlightedText={highlightedText} />
          </span>
        </span>
      ))}
    </span>
  );
}
